import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[420px] md:min-h-[480px] flex items-center overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20cinematic%20background%20with%20dramatic%20red%20and%20black%20gradient%2C%20mysterious%20atmosphere%2C%20soft%20glowing%20particles%2C%20editorial%20photography%20style%2C%20dark%20theme%2C%20luxury%20noir%20aesthetic%2C%20minimalist%20geometric%20shapes%2C%20deep%20shadows%2C%20elegant%20composition&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="51爆料网 - 每日爆料黑料吃瓜"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-14 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 text-center lg:text-left">
            <nav aria-label="面包屑导航" className="mb-3">
              <ol className="flex items-center justify-center lg:justify-start gap-2 text-sm text-foreground-400">
                <li><Link to="/" className="hover:text-primary-400 transition-colors">首页</Link></li>
                <li><span className="text-foreground-600">/</span></li>
                <li><span className="text-primary-400">今日热点</span></li>
              </ol>
            </nav>

            <h1 className="text-3xl md:text-5xl lg:text-5xl font-heading font-bold text-foreground-50 leading-tight mb-4">
              51今日大瓜
              <span className="block text-primary-400 mt-1">每日爆料黑料吃瓜</span>
            </h1>

            <p className="text-foreground-400 text-base md:text-lg leading-relaxed max-w-lg mx-auto lg:mx-0 mb-6">
              每日大赛往期内容、独家八卦、往期精华免费回顾。娱乐圈最新最全的爆料资讯平台，吃瓜不停，立即查看。
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#highlights"
                className="px-6 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
              >
                立即吃瓜
                <i className="ri-arrow-right-line ml-2" />
              </a>
              <Link
                to="/category/meiri-dasai"
                className="px-6 py-3 border border-foreground-700/40 text-foreground-300 font-medium rounded-full hover:border-foreground-400 hover:text-foreground-100 transition-all duration-200 whitespace-nowrap text-sm"
              >
                往期大赛回顾
              </Link>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-6 mt-6 text-foreground-500 text-xs">
              <div className="flex items-center gap-1.5">
                <i className="ri-fire-line text-primary-400" />
                <span>日均爆料 <strong className="text-foreground-300">50+</strong></span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-user-line text-primary-400" />
                <span>吃瓜用户 <strong className="text-foreground-300">1000万+</strong></span>
              </div>
              <div className="flex items-center gap-1.5">
                <i className="ri-thumb-up-line text-primary-400" />
                <span>累计爆料 <strong className="text-foreground-300">2万+</strong></span>
              </div>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex items-center justify-center">
            <div className="relative w-full max-w-md">
              <img
                src="https://readdy.ai/api/search-image?query=Dark%20abstract%20entertainment%20news%20concept%20with%20glowing%20red%20accents%2C%20mysterious%20silhouette%2C%20newspaper%20fragments%20flying%2C%20dramatic%20lighting%2C%20editorial%20style%2C%20dark%20background%2C%20cinematic%20composition%2C%20high%20contrast%2C%20noir%20aesthetic&width=800&height=500&seq=hero-illustration-2026&orientation=landscape"
                alt="51爆料网独家八卦资讯"
                className="w-full h-auto rounded-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}